import React, { useEffect } from "react";
import R from "ramda";
import { NavLink } from "react-router-dom";
import { Box, Button, Typography } from "@material-ui/core";

import { useUsers, useScreen, useTransactionRecords } from "hooks";
import { appRoutes } from "routes";
import Placeholder from "components/Placeholder";
import UserPresenter from "presenters/UserPresenter";
import SubscriptionPresenter from "presenters/SubscriptionPresenter";
import noMembershipDesktop from "assets/images/account/desktop-banner.png";
import noMembershipMobile from "assets/images/account/mobile-banner.png";

import SectionHeader from "../SectionHeader";

import useStyles from "./useStyles";

const BillingInfo = () => {
  const classes = useStyles();
  const { isMobile } = useScreen();
  const { currentUser } = useUsers();
  const { loadTransactionRecords, transactionRecords } = useTransactionRecords();
  const bannerImg = isMobile ? noMembershipMobile : noMembershipDesktop;
  const subscription = UserPresenter.activeSubscription(currentUser);
  const hasReceipts = !R.isNil(transactionRecords) && !R.isEmpty(transactionRecords);

  useEffect(() => {
    loadTransactionRecords();
  }, []);

  return (
    <>
      <SectionHeader>Billing Info</SectionHeader>

      {!currentUser && <Placeholder variant="rect" className={classes.placeholder} />}

      {currentUser && UserPresenter.isPaid(currentUser) && (
        <div className={classes.row}>
          <div className={classes.column}>
            <Typography>
              <b>Your Membership</b>
            </Typography>
            <Typography className={classes.offerDescription}>
              {SubscriptionPresenter.gifted(subscription)
                ? "Gift Subscription"
                : SubscriptionPresenter.offerDescription(subscription)}
            </Typography>
          </div>
          <div className={classes.column}>
            <NavLink className={classes.link} to={appRoutes.subscriptionDetailsPath()}>
              Edit Membership
            </NavLink>
            {hasReceipts && UserPresenter.isPaid(currentUser) && (
              <NavLink className={classes.link} to={appRoutes.receiptsPath()}>
                View Receipts
              </NavLink>
            )}
          </div>
        </div>
      )}

      {currentUser && !UserPresenter.isPaid(currentUser) && (
        <div className={classes.free}>
          <div className={classes.row}>
            <Typography>
              <b>No Active Membership</b>
            </Typography>
            {hasReceipts && (
              <NavLink className={classes.link} to={appRoutes.receiptsPath()}>
                View Receipts
              </NavLink>
            )}
          </div>

          <div className={classes.row}>
            <Box className={classes.membershipImgWrapper}>
              <NavLink to={appRoutes.paymentPath()}>
                <img className={classes.membershipImg} src={bannerImg} alt="Buy Membership" />
              </NavLink>
            </Box>
          </div>

          <Box className={classes.box}>
            <NavLink to={appRoutes.paymentPath()}>
              <Button variant="contained" color="secondary">
                Join JibJab
              </Button>
            </NavLink>
          </Box>
        </div>
      )}
    </>
  );
};

export default BillingInfo;
